(() => {
  let selected = null;
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const updateCopy = (scope = document) => {
    if (!selected) return;
    scope.querySelectorAll('[data-sr-template]').forEach((node) => {
      let value = node.dataset.srTemplate;
      const tokens = {"[precio]": selected.price, "[Comparar]": selected.compare, '[risparmio]': selected.saving, '[email]': selected.email};
      Object.entries(tokens).forEach(([token, replacement]) => {
        const span = document.createElement('span');
        span.textContent = replacement || '';
        value = value.split(token).join(span.innerHTML);
      });
      node.innerHTML = value;
    });
  };
  const initGallery = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-sr-slide]')];
    const thumbs = [...root.querySelectorAll('[data-sr-thumb]')];
    if (!slides.length) return;
    let active = 0;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== active;
        if (i !== active) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
      root.querySelector('[data-sr-counter]').textContent = `${active + 1} / ${slides.length}`;
      if (matchMedia('(max-width: 767px)').matches) {
        const strip = thumbs[active].parentElement;
        strip.scrollTo({left: thumbs[active].offsetLeft - strip.offsetLeft - (strip.clientWidth - thumbs[active].clientWidth) / 2, behavior: reduceMotion() ? 'instant' : 'smooth'});
      }
    };
    thumbs.forEach((button, i) => button.addEventListener('click', () => show(i)));
    root.querySelector('[data-sr-prev]').addEventListener('click', () => show(active - 1));
    root.querySelector('[data-sr-next]').addEventListener('click', () => show(active + 1));
    const swipe = root.querySelector('[data-sr-swipe]');
    let x = null, y = null;
    swipe.addEventListener('touchstart', (event) => { x = event.touches[0]?.clientX; y = event.touches[0]?.clientY; }, {passive: true});
    swipe.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (touch && x != null && Math.abs(touch.clientX - x) > 50 && Math.abs(touch.clientX - x) > Math.abs(touch.clientY - y)) show(active + (touch.clientX < x ? 1 : -1));
      x = y = null;
    }, {passive: true});
    document.addEventListener('shopify:block:select', (event) => {
      const index = thumbs.findIndex((button) => button.dataset.blockId === event.detail.blockId);
      if (root.isConnected && index >= 0) show(index);
    });
  };
  const initProduct = (root) => {
    if (root.dataset.ready) return;
    const json = root.querySelector('[data-sr-variants]');
    if (!json) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(json.textContent);
    const form = root.querySelector('form');
    const variantSelect = form.querySelector('[name="id"]');
    const quantity = form.querySelector('[name="quantity"]');
    const button = form.querySelector('[data-sr-add]');
    const error = form.querySelector('[data-sr-error]');
    const choose = () => {
      const variant = config.variants.find((v) => String(v.id) === variantSelect.value);
      if (!variant) { button.disabled = true; return; }
      selected = {...variant, email: config.email};
      button.disabled = !variant.available;
      button.textContent = variant.available ? config.buy : config.soldOut;
      quantity.min = variant.min;
      quantity.step = variant.step;
      if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
      quantity.value = variant.min;
      const stock = root.querySelector('[data-sr-stock]');
      if (stock) stock.textContent = variant.available ? config.available : config.soldOut;
      updateCopy();
    };
    variantSelect.addEventListener('change', choose);
    choose();
    form.addEventListener('vertaline:form:ready', () => {
      const variant = config.variants.find((v) => String(v.id) === variantSelect.value);
      button.disabled = !variant?.available;
      button.textContent = variant?.available ? config.buy : config.soldOut;
    });
  };
  const initTimer = (node) => {
    if (node.dataset.ready) return;
    node.dataset.ready = 'true';
    const root = node.closest('[data-sr-timer-mode]');
    const end = root?.dataset.srTimerMode === 'fixed' ? new Date(root.dataset.srTimerEnd) : new Date();
    if (root?.dataset.srTimerMode !== 'fixed') end.setHours(23, 59, 59, 0);
    const tick = () => {
      const remaining = Number.isFinite(end.getTime()) ? Math.max(0, end.getTime() - Date.now()) : 0;
      const pad = (n) => String(Math.floor(n)).padStart(2, '0');
      node.textContent = `${pad(remaining / 3600000)}h : ${pad((remaining % 3600000) / 60000)}m : ${pad((remaining % 60000) / 1000)}s`;
    };
    tick();
    const timer = setInterval(() => { if (!node.isConnected) clearInterval(timer); else tick(); }, 1000);
  };
  const scan = (scope = document) => {
    scope.querySelectorAll('[data-sr-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-sr-product]').forEach(initProduct);
    scope.querySelectorAll('[data-sr-countdown]').forEach(initTimer);
    updateCopy(scope);
  };
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
